import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login, formatError } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Logged in. Slay.");
      const to = loc.state?.from || "/";
      navigate(to);
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-14">
      <h1 className="font-display text-5xl tracking-tighter mb-2">welcome back<span className="text-hot">.</span></h1>
      <p className="font-mono-tag text-xs uppercase mb-6">log in to drop new slang</p>

      <form onSubmit={onSubmit} className="bg-white brutal p-6 space-y-4">
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">email</label>
          <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none font-display" />
        </div>
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">password</label>
          <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none font-display" />
        </div>

        {error && <p data-testid="login-error" className="bg-hot text-white brutal-sm px-3 py-2 font-mono-tag text-xs uppercase">{error}</p>}

        <button data-testid="login-submit-btn" type="submit" disabled={loading}
          className="w-full bg-hot text-white font-display uppercase py-3 brutal-sm brutal-hover brutal-active disabled:opacity-60">
          {loading ? "..." : "Log in"}
        </button>
      </form>

      <p className="mt-4 font-mono-tag text-xs uppercase">
        no account? <Link data-testid="link-to-register" to="/register" className="underline decoration-2">register here</Link>
      </p>
    </div>
  );
}
